<template>
  <a-card :bordered="false" title="积分规则" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row style="margin-bottom: 20px;">
      <a-col :span="18">
        <a-input-search v-model="searchQueryParams.pointRuleName" placeholder="请输入积分规则名称" style="width: 350px"
                        @search="onSearch"/>
        <a-button type="primary" style="margin-left: 10px" @click="onNewPage(0)">新建积分规则</a-button>
      </a-col>
      <a-col :span="6" style="text-align: right;">积分规则 <a @click="openModel">设置</a></a-col>
    </a-row>
    <custom-page-table
      ref="table"
      :columns="getColumnsList()"
      :queryParams="searchQueryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="onNewPage(rowItem.record.id)">编辑</a>
        <span v-if="rowItem.record.isPreset!=1">
          <a-divider type="vertical"></a-divider>
          <a-popconfirm title="确认删除此条数据吗?" @confirm="onDelete(rowItem.record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </span>
    </custom-page-table>
    <a-modal title="积分规则设置" :width="700" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 15 }">
        <a-form-model-item label="积分状态" required>
          <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.status"/>
        </a-form-model-item>
        <a-form-model-item label="积分规则说明">
          <a-textarea v-model="ruleForm.pointRuleDesc" placeholder="请输入" :auto-size="{ minRows: 3, maxRows: 3 }"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 15,offset: 5 }" style="margin-bottom: 0;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button @click="handleCancel" style="margin-left: 10px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'IntegralRuleList',
  mixins: [],
  components: {},
  data() {
    return {
      searchQueryParams: {
        pointRuleName: '',
        merchantId: this.$store.getters.userInfo.merchantId
      },
      loadPromise: params => this.getListPromise(params),
      visible: false,
      ruleForm: {
        id: 0,
        status: false,
        pointRuleDesc: ''
      },
      rules: {
        climbingCycle: [{ required: true, message: '请选择会员等级周期', trigger: 'change' }]
      },
      submitLoading: false
    }
  },
  mounted() {
  },
  methods: {
    onSearch() {
      this.$refs.table.refresh(true)
    },
    onNewPage(id) {
      const params = { id }
      this.openNewPage('NewIntegralRule', params)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getIntegralApiService().post('admin/pointsRule/listPage', params)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.status = params.status ? 1 : 0
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getIntegralApiService().post('admin/pointsRule/setting/update', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.visible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.getRuleDetail()
    },
    handleCancel() {
      this.visible = false
    },
    getRuleDetail() {
      this.getHttpServices().getIntegralApiService().post('admin/pointsRule/setting/detail').then(res => {
        if (res && res.id) {
          this.visible = true
          this.ruleForm = { ...res }
          this.ruleForm.status = res.status == 1 ? true : false
        } else {
          this.resetRuleForm()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    resetRuleForm() {
      this.ruleForm = {
        id: 0,
        status: false,
        pointRuleDesc: ''
      }
    },
    getColumnsList() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '积分规则名称',
          dataIndex: 'pointRuleName'
        },
        {
          title: '可获积分',
          dataIndex: 'availablePoint'
        },
        {
          title: '参与周期',
          dataIndex: 'partakeCycleStr'
        },
        {
          title: '类型',
          dataIndex: 'ruleTypeStr'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    onDelete(id) {
      this.getHttpServices().getIntegralApiService().post('admin/pointsRule/del/' + id).then(res => {
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
